import { GraphIcon2 } from '~/@mid_ui/icons/GraphIcon2'
import { TollIcon } from '~/@mid_ui/icons/TollIcon'
import { TransactionIcon } from '~/@mid_ui/icons/TransactionIcon'
import { FileCopyIcon } from '~/@mid_ui/icons/FileCopyIcon'
import { FinancialOverviewTab } from './financial-overview/FinancialOverviewTab'
import { InvestmentsTab } from './investments/InvestmentsTab'
import { InvestorTransactionsTab } from './transactions/TransactionsTab'
import { DocumentsTab } from './documents/DocumentsTab'

function usePortfolioTabs() {
  return [
    {
      label: 'Prehľad',
      icon: <GraphIcon2 className="w-4.5! h-4.5!" />,
      value: '',
      component: <FinancialOverviewTab />,
    },
    {
      label: 'Moje investície',
      icon: <TollIcon className="w-4.5! h-4.5!" />,
      value: '/investments',
      component: <InvestmentsTab />,
    },
    {
      label: 'Moje transakcie',
      icon: <TransactionIcon className="w-4.5! h-4.5!" />,
      value: '/transactions',
      component: <InvestorTransactionsTab />,
    },
    {
      label: 'Dokumenty',
      icon: <FileCopyIcon className="w-4.5! h-4.5!" />,
      value: '/documents',
      component: <DocumentsTab />,
    },
  ]
}

export { usePortfolioTabs }
